export default __webpack_public_path__ + "static/ai-after-hours-banner-273952cd0506b1dd31973fac22fc8148.png";